import { BASE_URL } from '../endpoints'
import { post } from '../https'

interface passwordData {
  password: string
  confirmPassword: string
  token:string
}

interface forgetpasswordData {
  userId: string
  newPassword: string
  confirmPassword: string
  token: string
}

export const setupPassword = (
  data: passwordData,
  uid: string | undefined
): Promise<unknown> => {
  return post(`${BASE_URL}/setup-password/${uid}`, data, null)
}

export const setupPasswordVerification = (
  data: {
    token: string | undefined | null
  },
  uid: string | undefined | null
): Promise<unknown> => {
  return post(`${BASE_URL}/setup-password-verification/${uid}`, data, null)
}

export const setupEmailVerification = (data: {
  userId: string | undefined | null
  token: string | undefined | null
}): Promise<unknown> => {

  return post(`${BASE_URL}/verify-email`, data, null)
}

export const forgetPassword = (email: string): Promise<unknown> => {
  return post(
    `${BASE_URL}/forget-password`,
    {
      email: email,
    },
    null
  )
}
export const setupResetPassword = (
  data: forgetpasswordData
): Promise<unknown> => {
  return post(`${BASE_URL}/reset-password`, data, null)
}

export const resendVerificationEmail = (email: string): Promise<unknown> => {
  return post(
    `${BASE_URL}/email-verification`,
    {
      email: email,
    },
    null
  )
}

